export default "__VITE_ASSET__aNVtmeMS__"